module.exports = __webpack_public_path__ + "img/DE.3ecc74aa.svg";